import React, { useState } from "react";

function useForm() {
  const [value, setValue] = useState("");
  const [error, setError] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const onChange = (e) => {
    if (parseInt(e.target.value) < 0) {
      setValue(Math.abs(parseInt(e.target.value)));
    } else {
      setValue(e.target.value);
    }
  };

  const onFocus = (e) => {
    setError(false);
    setErrorMsg("");
  };

  const onDateChange = (text) => {
    console.log(text);
    setValue(text);
  };

  return {
    value,
    error,
    errorMsg,
    onChange,
    setError,
    setValue,
    setErrorMsg,
    onDateChange,
    onFocus
  };
}

export default useForm;
